if (!customElements.get('component-product-options')) {
  customElements.define('component-product-options', class ProductOptionsComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.options = this.querySelectorAll(this.dataset.optionSelector);
      this.addEventListeners();
      
      if(this.classList.contains('component-product-options-boxes') && !this.closest('cart-drawer')) {
        this.checkWidth();
      }
    }

    checkWidth() {
      const componentProductOptionOffsetWidth = this.offsetWidth;
      const componentProductOptionScrollWidth = this.scrollWidth;
      if(componentProductOptionScrollWidth > componentProductOptionOffsetWidth) {
        this.children[this.children.length - 2].remove();
        this.checkWidth();
      } else {
        this.style.visibility = 'visible';
        const visibleVariantsCount = this.children.length - 1;
        const unvisibleVariantsCount = (+this.lastElementChild.dataset.variantSize) - visibleVariantsCount;

        if (unvisibleVariantsCount === 0) {
          return this.lastElementChild.style.display = 'none';
        }

        this.lastElementChild.textContent = '+ ' + unvisibleVariantsCount
        this.lastElementChild.style.display = 'block';
      }
    }

    addEventListeners() {
      for (let option of this.options) {
        option.addEventListener('click', this.onOptionClickHandler.bind(this));
      }
    }

    updateURL(currentVariant) {
      if (!currentVariant) return;
      const productURLpath = window.location.pathname;
      window.history.replaceState({ }, '', `${productURLpath}?variant=${currentVariant}`);
    }

    async onOptionClickHandler(event) {
      const current = event.currentTarget;
      const productCardItem = this.closest('product-card-item');
      const swymButtonComponent = document.getElementById(this.dataset.swymComponentId);
      
      // show variants popup button click
      if(current.classList.contains('component-product-options-boxes-quantity')) {
        productCardItem.openVariantsPopup(this.dataset.variantsPopupId, current);
      }
      // wishlist variant 
      else if(this.dataset.wishlistPopup) {
        if(current.classList.contains('disable')) {
          let allWishlistButtonsShouldRemoveDisable = document.querySelectorAll('.component-product-card-wishlist' +'[data-variant-id="' + current.dataset.variantId + '"]');
          let allWishlistOptionsShouldRemoveDisable = document.querySelectorAll('.component-product-options__option.disable' +'[data-variant-id="' + current.dataset.variantId + '"]');
          swymButtonComponent.removeFromWishList({
            epi: +current.dataset.variantId,
            empi: +this.dataset.productId,
            du: location.origin + this.dataset.productUrl,
          });
          for(let wishlistButtonShouldRemoveDisable of allWishlistButtonsShouldRemoveDisable) {
            wishlistButtonShouldRemoveDisable.classList.remove('disable');
          }
          for(let wishlistOptionhouldRemoveDisable of allWishlistOptionsShouldRemoveDisable) {
            wishlistOptionhouldRemoveDisable.classList.remove('disable');
          }
          current.classList.remove('disable');
        } else {
          let imageURL = this.dataset.productImage;
          swymButtonComponent.addToWishList({
            epi: +current.dataset.variantId,
            empi: +this.dataset.productId,
            du: location.origin + this.dataset.productUrl,
            cprops: {
              title: current.dataset.title,
              variantTitle: current.dataset.variantTitle,
              imageURL: imageURL
            }
          });
        }
        swymButtonComponent.children[0].dataset.variantId  = current.dataset.variantId;
        swymButtonComponent.children[0].dataset.variantTitle = current.dataset.variantTitle;
      }
      else {
        swymButtonComponent.children[0].dataset.variantId  = current.dataset.variantId;
        swymButtonComponent.children[0].dataset.variantTitle = current.dataset.variantTitle;
        const addToCartButtonComponent = document.getElementById(this.dataset.addToCartComponentId);
        // temporary solution for "Send as a gift" Button START
        const sendAsAGiftButton = document.querySelector('.btn-send-as-gift');
        const fakeSendAsAGiftButton = document.querySelector('.fake-send-as-a-gift-button');

        sendAsAGiftButton && sendAsAGiftButton.classList.remove('hidden');
        fakeSendAsAGiftButton && fakeSendAsAGiftButton.classList.add('hidden');
        // temporary solution for "Send as a gift" Button END

        addToCartButtonComponent && addToCartButtonComponent.updateVariant(current.dataset.variantId, current.dataset.status);
        
        if (current.dataset.type === 'select') {
          await addToCartButtonComponent.onButtonClickHandler();
          if (current.dataset.status === 'addtocart' || current.dataset.status === 'presale') {
            const productHandle = this.closest('[data-product-handle]').dataset.productHandle;
            const hasProductFrequentlyBoughtTogetherProducts = this.closest('[data-hasfbtproducts]') ? this.closest('[data-hasfbtproducts]').dataset.hasfbtproducts : false;
            if (!this.closest('[data-collection-add-to-cart-popup]')) {
              const collectionAddToCartPopup = document.querySelector('[data-collection-add-to-cart-popup]');
              collectionAddToCartPopup && hasProductFrequentlyBoughtTogetherProducts == "true" ? collectionAddToCartPopup.handleCollectionPopupRender(productHandle) : 'false';
            }
          }
        }

        if (current.dataset.type === 'button') {
          [...this.options].find(element => element.classList.contains('component-product_option-active') && element.classList.remove('component-product_option-active'));
          current.classList.add('component-product_option-active');
          this.updateURL(current.dataset.variantId);
          swymButtonComponent.children[0].dataset.action = 'add';

          let listContents = await app.swymApi.getListContents();
          swymButtonComponent.initWishlist(listContents);  
       
          const chooseSizeNotification = document.querySelector('.component-choose-size');
          chooseSizeNotification && chooseSizeNotification.classList.add('hidden');
        }
      }

      this.blur();
    }
  });
};
